import axios from "axios";
const API_BASE_URL = "https://daryeelinspection.com/api/";
// const API_BASE_URL = "http://localhost:5000/api/";
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = JSON.parse(localStorage.getItem("authUser"))?.token;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);
export default apiClient;
